/* src/app/builder-screen-beta/components/master-detail-panel/master-detail-panel.component.scss */
.master-detail-panel.slide-mode {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  background: #ffffff;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  animation: slideInRight 0.3s ease-out;
}
.master-detail-panel.slide-mode.resizing {
  -webkit-user-select: none;
  user-select: none;
}
.master-detail-panel.slide-mode.resizing .panel-divider {
  background: #1890ff;
}
.master-detail-panel.slide-mode.pinned {
  z-index: 999;
}
.panel-divider {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 8px;
  background: #d9d9d9;
  cursor: col-resize;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s ease;
  z-index: 10;
}
.panel-divider:hover {
  background: #1890ff;
}
.panel-divider:hover .divider-handle {
  opacity: 1;
}
.panel-divider .divider-handle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 60px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 4px;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}
.panel-divider .divider-handle i {
  color: #1890ff;
  font-size: 16px;
}
.master-detail-panel.sheet-mode {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  background: #ffffff;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
  border-radius: 16px 16px 0 0;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  animation: slideInUp 0.3s ease-out;
}
.master-detail-panel.sheet-mode.minimized {
  max-height: 88px;
}
.master-detail-panel.sheet-mode.minimized .panel-content,
.master-detail-panel.sheet-mode.minimized .panel-footer {
  display: none;
}
.sheet-handle {
  display: flex;
  justify-content: center;
  padding: 12px 0 8px;
  cursor: pointer;
}
.sheet-handle .handle-bar {
  width: 48px;
  height: 4px;
  background: #d9d9d9;
  border-radius: 2px;
  transition: background 0.2s ease;
}
.sheet-handle:hover .handle-bar {
  background: #bfbfbf;
}
.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  background: #fafafa;
  flex-shrink: 0;
  height: 56px;
  box-sizing: border-box;
}
.panel-header .panel-title {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 16px;
  font-weight: 600;
  color: #262626;
}
.panel-header .panel-title i {
  font-size: 20px;
  color: #1890ff;
}
.panel-header .panel-actions {
  display: flex;
  gap: 8px;
}
.panel-header .panel-actions button {
  opacity: 0.7;
  transition: opacity 0.2s ease;
}
.panel-header .panel-actions button:hover {
  opacity: 1;
}
.panel-content {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px;
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}
.panel-content::-webkit-scrollbar {
  width: 8px;
}
.panel-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
.panel-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}
.panel-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
.form-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.form-container ::ng-deep .ant-form-item {
  margin-bottom: 16px;
}
.form-container ::ng-deep .ant-input,
.form-container ::ng-deep .ant-input-number,
.form-container ::ng-deep .ant-select {
  width: 100%;
}
.form-field-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.form-field-item .field-label {
  font-weight: 500;
  font-size: 14px;
  color: #262626;
  margin-bottom: 4px;
}
.form-field-item .field-label::after {
  content: ":";
  margin-left: 2px;
}
.form-field-item .field-input {
  width: 100%;
}
.form-field-item .field-input,
.form-field-item .field-input input {
  color: rgba(0, 0, 0, 0.85) !important;
}
.form-field-item nz-switch.field-input {
  width: auto;
}
.panel-footer {
  display: flex;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid #f0f0f0;
  background: #fafafa;
  flex-shrink: 0;
  height: 64px;
  box-sizing: border-box;
}
.panel-footer button {
  flex: 1;
}
.panel-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 999;
  animation: fadeIn 0.3s ease-out;
  cursor: pointer;
}
@keyframes slideInRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes slideInUp {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@media (min-width: 1441px) {
  .master-detail-panel.slide-mode {
    max-width: 800px;
  }
}
@media (min-width: 1024px) and (max-width: 1440px) {
  .master-detail-panel.slide-mode {
    max-width: 60%;
  }
}
@media (max-width: 1023px) {
  .master-detail-panel.slide-mode {
    left: 0;
    right: 0;
    top: auto;
    width: 100% !important;
    max-height: 70vh;
    border-radius: 16px 16px 0 0;
    animation: slideInUp 0.3s ease-out;
  }
  .panel-divider {
    display: none;
  }
}
@media (max-width: 767px) {
  .master-detail-panel.slide-mode,
  .master-detail-panel.sheet-mode {
    max-height: 85vh;
  }
  .master-detail-panel.slide-mode .panel-content,
  .master-detail-panel.sheet-mode .panel-content {
    padding: 16px;
  }
  .master-detail-panel.slide-mode .panel-footer,
  .master-detail-panel.sheet-mode .panel-footer {
    flex-direction: column;
    height: auto;
    gap: 8px;
  }
  .master-detail-panel.slide-mode .panel-footer button,
  .master-detail-panel.sheet-mode .panel-footer button {
    width: 100%;
  }
  .panel-header {
    padding: 12px 16px;
    height: auto;
  }
  .panel-header .panel-title {
    font-size: 14px;
    gap: 8px;
  }
  .panel-header .panel-title i {
    font-size: 18px;
  }
}
@media (min-width: 1024px) {
  .master-detail-panel.slide-mode:hover .panel-divider {
    opacity: 1;
  }
}
.form-container ::ng-deep .ant-input:focus,
.form-container ::ng-deep .ant-input-number:focus,
.form-container ::ng-deep .ant-select:focus {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}
/*# sourceMappingURL=master-detail-panel.component.css.map */
